import { ButtonCust, SimpleModal } from "../../../../widgets";
import { Box, Typography } from "@mui/material";
import EnvConfig from "../../../../../config/env.config.json";
import { GetCurrencyFixedToTwo } from "../../../../../utils/commonFunctions/GetCurrencyFixedToTwo";
import { gtmTagManager } from "../../../../../utils/commonFunctions/GtmTagManager";
import { useAppSelector } from "../../../../../app/hooks";
import { Add, Remove } from "@mui/icons-material";
import styles from "./S2_AddCredits.module.scss";

const T2_AddCredits = (props: any) => {
  const { add_credit_details, primary_txt, dec_inc_icon } = props.content;
  const { globalVal } = useAppSelector(
    (state: any) => state?.strapi?.globalValues || {}
  );
  const {
    openCreditModal,
    setOpenCreditModal,
    userLineData,
    creditAmount,
    setcreditAmount,
    configKeys,
    handleConfirmPurchase,
    addCreditIncDecHandler,
  } = props;

  return (
    <SimpleModal
      isShowModal={openCreditModal ? true : false}
      onCloseModal={() => {
        setOpenCreditModal(false);
        setcreditAmount(Number(configKeys?.ILD_INCR_CREDIT_AMOUNT));
      }}
      showClose={true}
      sx={{
        width: { xs: "90%", sm: "60%", md: "30%", lg: "30%", xl: "30%" },
        borderRadius: "12px",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          fontSize: { xs: "18px", md: "24px" },
          fontWeight: "var(--font_weight_4)",
          color: "var(--title-color_1)",
          fontFamily: "var(--font_family_Bold)",
        }}
      >
        {add_credit_details.title}
      </Box>
      <Typography
        component={"div"}
        sx={{
          margin: "20px",
        }}
      >
        <Box
          component="span"
          sx={{
            fontSize: "16px",
            fontFamily: "var(--font_family_Regular)",
            color: "var(--text_color)",
            fontWeight: "var(--font_weight_0)",
          }}
        >
          {add_credit_details.lineTxt}
        </Box>{" "}
        <Box
          component="span"
          sx={{
            fontSize: "16px",
            fontFamily: "var(--font_family_Regular)",
            color: "var(--text_color)",
            fontWeight: "var(--font_weight_0)",
            textTransform: "capitalize",
          }}
        >
          {userLineData?.firstName?.toLowerCase()}{" "}
          {userLineData?.lastName?.toLowerCase()}
        </Box>{" "}
      </Typography>
      <Box
        sx={{
          fontSize: "16px",
          fontFamily: "var(--font_family_Regular)",
          color: "var(--text_color)",
          fontWeight: "var(--font_weight_0)",
        }}
      >
        {add_credit_details.desc}
      </Box>
      <Box
        component="div"
        sx={{
          display: "flex",
          justifyContent: "center",
          gap: "18px",
          margin: "30px 0 15px",
          alignItems: "center",
        }}
      >
        {/* <Box
          component="img"
          alt={dec_inc_icon?.data[0].attributes?.alternativeText || ""}
          src={
            creditAmount === Number(configKeys?.ILD_INCR_CREDIT_AMOUNT)
              ? dec_inc_icon?.data[0].attributes?.url
              : dec_inc_icon?.data[1].attributes?.url || ""
          }
          sx={{
            cursor: "pointer",
          }}
          onClick={() => addCreditIncDecHandler("dec")}
        /> */}

        <Remove
          onClick={() => addCreditIncDecHandler("dec")}
          sx={{
            cursor: "pointer",
            color: "var(--primary_color)",
          }}
          className={
            creditAmount === Number(configKeys?.ILD_INCR_CREDIT_AMOUNT)
              ? `${styles.line_count_button} ${styles.button_disable}`
              : `${styles.line_count_button}`
          }
        />
        <Typography
          component="div"
          sx={{
            fontSize: { xs: "24px", md: "40px" },
            fontWeight: "var(--font_weight_4)",
            color: "var(--primary_color)",
            fontFamily: "var(--font_family_Bold)",
          }}
        >
          {GetCurrencyFixedToTwo(creditAmount)}
        </Typography>
        {/* <Box
          component="img"
          alt={dec_inc_icon?.data[2].attributes?.alternativeText || ""}
          src={dec_inc_icon?.data[2].attributes?.url || ""}
          sx={{
            cursor: "pointer",
          }}
          onClick={() => addCreditIncDecHandler("inc")}
        /> */}
        <Add
          onClick={() => addCreditIncDecHandler("inc")}
          sx={{
            cursor: "pointer",
            color: "var(--primary_color)",
          }}
          className={styles.line_count_button}
        />
      </Box>
      <Box
        sx={{
          width: "100%",
          height: "1px",
          background: "var(--lightgrey_6)",
        }}
      />
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          color: "var(--text_color)",
          fontFamily: "var(--font_family_Medium)",
          mt: "20px",
        }}
      >
        <Box sx={{ fontWeight: "var(--font_weight_2)" }}>
          {add_credit_details.pricePerCredit}
        </Box>
        <Box sx={{ fontWeight: "var(--font_weight_0)" }}>
          {add_credit_details.pricePerCreditval}
        </Box>
      </Box>
      <ButtonCust
        variantType={EnvConfig.PRIMARY_BUTTON_TYPE}
        sx={{
          mt: "5px",
          mb: "15px",
          height: "45px !important",
          width: "250px",
          // "&:hover": {
          //   backgroundColor: "var(--button_hover_color) !important",
          //   border: "1px solid var(--button_hover_color) !important",
          // },
        }}
        onClick={() => {
          handleConfirmPurchase();
          gtmTagManager({
            event: globalVal?.gtmEvents?.ILDContinuePurchase,
            click_section: "International Calling",
          });
        }}
      >
        {add_credit_details.btnTxt}
      </ButtonCust>
    </SimpleModal>
  );
};

export default T2_AddCredits;
